module.exports = ".actions-col {\n  white-space: nowrap;\n  width: 80px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/email/segments/segment-edit/segment-edit.component.scss
// module id = ./src/app/modules/email/segments/segment-edit/segment-edit.component.scss
// module chunks = main